import { useQuery } from "@tanstack/react-query";

import { FETCH_ERROR } from "../consts/fetch-error";
import { getProjects } from "../services/project";

export const useProjects = () => {
  return useQuery({
    queryKey: ["get-projects"],
    queryFn: () => getProjects(),
    staleTime: 1000 * 60 * 60, // 1 hour
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
};
